import { render } from "./DropBoxLocation.vue?vue&type=template&id=71b4ea10&scoped=true"
import script from "./DropBoxLocation.vue?vue&type=script&lang=js"
export * from "./DropBoxLocation.vue?vue&type=script&lang=js"

import "./DropBoxLocation.vue?vue&type=style&index=0&id=71b4ea10&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b4ea10"]])

export default __exports__